import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import queryString from "query-string";
import Loader from "../../../assets/icons/loader/loader";
import DeleteModal from "../../../components/modal/delete-modal";
import AdminFilterDrawer from "../../../components/filter/admin-filter-drawer";
import LeadActivityCreateModal from "./leads-activity-create-modal";
import LeadActivityEditModal from "./leads-activity-edit-modal";
import LeadActivityViewModal from "./leads-activity-view-modal";
import { api } from "../../../redux/apis/api";
import { useRole } from "../../../context/role/RoleContext";

const LeadsActivityList = ({ activeTab }) => {
  const location = useLocation();
  const { id } = useParams();
  const { state } = useRole();
  const permission = state?.role?.lead_activity;
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);

  const [data, setData] = useState({
    rows: [],
    page: 1,
    count: 0,
  });
  const [loading, setLoading] = useState(true);
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [deleteModalShow, setdeleteModalShow] = useState(false);
  const [selectDelete, setSelectDelete] = useState("");
  const [leadsCreate, setLeadsCreate] = useState(false);
  const [leadsEdit, setLeadsEdit] = useState(false);
  const [leadsView, setLeadsView] = useState(false);
  const [selectID, setSelectID] = useState("");
  const [ViewDeleteModalShow, setViewDeleteModalShow] = useState(false);

  const writePermission = (row) => {
    if (row.assignedTo) {
      if (row.assignedTo.write == true) {
        return true;
      }
      return false;
    }
    if (permission?.write == true) {
      return true;
    }
  };

  const fetchData = () => {
    const rawFilters = queryString.parse(location.search, {
      arrayFormat: "bracket",
    });

    const filters = normalizeParsedParams(rawFilters);

    setLoading(true);
    api
      .post(`/lead/activity/list`, {
        page: page_no,
        lead_id: id,
        ...filters,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  function normalizeParsedParams(parsed) {
    const result = {};

    for (const [key, value] of Object.entries(parsed)) {
      const match = key.match(/^(\w+)\[(\w+)\]$/);
      if (match) {
        const [, parent, child] = match;
        if (!result[parent]) result[parent] = {};
        result[parent][child] = value;
      } else {
        result[key] = value;
      }
    }

    return result;
  }

  useEffect(() => {
    fetchData();
  }, [page_no, location.search]);

  const deleteFnc = (id) => {
    api
      .post(`/lead/activity/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  const ViewDeleteFnc = (id) => {
    api
      .post(`/lead/activity/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  const filterInputs = [
    {
      label: "title",
      type: "text",
      name: "title",
    },
    {
      label: "status",
      type: "dropdown",
      name: "status",
      options: [
        { label: "cancelled", value: "cancelled" },
        { label: "confirmed", value: "confirmed" },
        { label: "completed", value: "completed" },
      ],
    },
    {
      label: "type",
      type: "dropdown",
      name: "type",
      options: [
        { label: "call", value: "call" },
        { label: "sms", value: "sms" },
        { label: "quotation", value: "quotation" },
        { label: "visit", value: "visit" },
        { label: "meeting", value: "meeting" },
        { label: "complain resolution", value: "complain_resolution" },
        { label: "sales visit", value: "sales_visit" },
        { label: "sample request", value: "sample_request" },
        { label: "follow up", value: "follow_up" },
      ],
    },
    {
      label: "activity date",
      type: "date",
      name: "activity_date",
    },
    {
      label: "created At",
      type: "date",
      name: "createdAt",
    },
    {
      label: "updated At",
      type: "date",
      name: "updatedAt",
    },
  ];

  return (
    <section className="flex flex-col justify-between h-full">
      <DeleteModal
        isOpen={deleteModalShow}
        onClose={() => {
          setdeleteModalShow(false);
          setSelectDelete("");
        }}
        btnFnc={() => deleteFnc(selectDelete)}
      />

      {/* ------------- FOR VIEW ------------- */}
      <DeleteModal
        isOpen={ViewDeleteModalShow}
        onClose={() => {
          setViewDeleteModalShow(false);
          setSelectDelete("");
        }}
        viewDeleteFnc={() => {
          setLeadsView(true);
          setSelectID(selectID);
        }}
        btnFnc={() => ViewDeleteFnc(selectID)}
      />

      <LeadActivityCreateModal
        isOpen={leadsCreate}
        onClose={() => {
          setLeadsCreate(false);
        }}
        listFnc={fetchData}
      />
      <LeadActivityEditModal
        selectID={selectID}
        isOpen={leadsEdit}
        onClose={() => {
          setLeadsEdit(false);
        }}
      />
      <LeadActivityViewModal
        selectID={selectID}
        isOpen={leadsView}
        onClose={() => {
          setLeadsView(false);
        }}
        deleteDisable={permission?.write}
        shareButton={permission?.write}
        listFnc={fetchData}
        onDeleteFnc={() => {
          setViewDeleteModalShow(true);
          setLeadsView(false);
        }}
      />
      <section>
        <div className="flex justify-between items-center mb-5">
          <h2 className="text-xl font-semibold capitalize">
            lead activity List
          </h2>
          <div className="flex gap-2 relative">
            <AdminFilterDrawer
              filterInputs={filterInputs}
              open={filterDrawerOpen}
              onClose={() => setFilterDrawerOpen(false)}
              queryParamsData={queryParamsData}
              activeTab={activeTab}
            />

            {permission?.write && (
              <button
                className="px-4 py-2 bg-blue-600 text-white rounded"
                onClick={() => setLeadsCreate(true)}
              >
                Create
              </button>
            )}
            <button
              onClick={() => setFilterDrawerOpen(true)}
              className="px-4 py-1 bg-secondary text-white rounded"
            >
              Filters
            </button>
          </div>
        </div>
        <div className="relative overflow-x-auto">
          <table className="w-full text-left rtl:text-right border border-gray-200">
            <thead className="text-gray-700 uppercase">
              <tr>
                <th
                  scope="col"
                  className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                >
                  id
                </th>

                <th
                  scope="col"
                  className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                >
                  FF admin
                </th>
                <th
                  scope="col"
                  className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                >
                  title
                </th>
                <th
                  scope="col"
                  className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                >
                  description
                </th>
                <th
                  scope="col"
                  className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                >
                  status
                </th>
                <th
                  scope="col"
                  className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                >
                  type
                </th>
                <th
                  scope="col"
                  className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                >
                  activity date
                </th>
                <th
                  scope="col"
                  className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                >
                  activity time
                </th>
                <th
                  scope="col"
                  className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td rowSpan={1}>
                    <div className="w-full flex justify-center py-5">
                      <div className="h-[100px] w-[100px]">
                        <Loader />
                      </div>
                    </div>
                  </td>
                </tr>
              ) : (
                <>
                  {data.rows?.length ? (
                    <>
                      {data.rows.map((row, index) => {
                        return (
                          <tr key={index} className="border-t bg-white">
                            <td className="p-1 px-2">{row?.id ?? "--"}</td>

                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.ffAdminUsers?.name ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.title ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.description ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.status ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.type ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.activity_date ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.activity_time ?? "--"}
                              </span>
                            </td>
                            <td className="py-2 sticky right-0 z-10">
                              <div className="flex gap-3 bg-white px-4">
                                <button
                                  onClick={() => {
                                    setLeadsView(true);
                                    setSelectID(row["id"]);
                                  }}
                                  className="text-secondary border-[1px] border-secondary px-3 py-1 rounded-md text-fs_14 hover:bg-green-50"
                                >
                                  View
                                </button>
                                {writePermission(row) ? (
                                  <button
                                    onClick={() => {
                                      setLeadsEdit(true);
                                      setSelectID(row["id"]);
                                    }}
                                    className="text-primary border-[1px] border-primary px-3 py-1 rounded-md text-fs_14 hover:bg-blue-50"
                                  >
                                    Edit
                                  </button>
                                ) : null}
                                {writePermission(row) && (
                                  <button
                                    onClick={() => {
                                      setdeleteModalShow(true);
                                      setSelectDelete(row["id"]);
                                    }}
                                    className="text-errorColor border-[1px] border-errorColor px-3 py-1 rounded-md text-fs_14 hover:bg-red-50"
                                  >
                                    Delete
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </>
                  ) : (
                    <tr>
                      <td>
                        <p className="text-center my-5">No data found</p>
                      </td>
                    </tr>
                  )}
                </>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </section>
  );
};

export default LeadsActivityList;
